import { render } from "./ShipTour.vue?vue&type=template&id=4e499e58&scoped=true"
import script from "./ShipTour.vue?vue&type=script&lang=js"
export * from "./ShipTour.vue?vue&type=script&lang=js"

import "./ShipTour.vue?vue&type=style&index=0&id=4e499e58&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e499e58"]])

export default __exports__